import request from '@host-panel/request';

import { CheckValidationByTypeResponse, WhitelistedUrlsCrudResponse } from './superAdminTypes';

export function fetchWhitelistedUrls(): Promise<WhitelistedUrlsCrudResponse> {
  return request(`/host-panel/whitelisted-urls`, {
    method: 'GET'
  });
}

export function addWhitelistedUrlRequest(domain: string): Promise<WhitelistedUrlsCrudResponse> {
  return request(`/host-panel/whitelisted-urls`, {
    method: 'POST',
    data: {
      domain
    }
  });
}

export function removeWhitelistedUrlRequest(domain: string): Promise<WhitelistedUrlsCrudResponse> {
  return request(`/host-panel/whitelisted-urls`, {
    method: 'DELETE',
    data: {
      domain
    }
  });
}

export async function checkValidationByType(
  cssStr: string,
  type: string
): Promise<CheckValidationByTypeResponse> {
  return request(`/host-panel/deployer/validation`, {
    method: 'POST',
    data: {
      content: cssStr,
      type
    }
  });
}
